import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Container = styled.div`
  height: 620px;
  width: 600px;
  margin-top: 70px;
  background: ${theme.colors.white};
  text-align: center;
  padding: 0 101px;
  ${theme.defaultContainerBoxShadow}
`;

export const Title = styled.h4`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-top: 58px;
`;

export const SubTitle = styled.p`
  font-size: 20px;
  font-weight: 400;
  line-height: 21px;
  margin: 24px 0 30px 0;
`;

export const Image = styled.img``;

export const Text = styled.p`
  margin: 47px 0 50px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
`;
